import React, { Component } from "react";
import * as _ from "lodash";
import { connect } from "react-redux";

/* Load Redux Store */
import { configurationsStoreSelectors } from "../../../../../store/store";

import { SoundsFilterSelected } from "../SoundsConfigurationSection.component";

import "./SoundsSearch.component.scss";
import {filterItemsBySelectedGames} from "../../../../Utils/selected-games";

export interface SoundSearchProps {
    searchAction: any;
    gameInstances: any;
    gameGroups: any[];
    selectedGroupType: string;
    selectedFilters: SoundsFilterSelected;
}

export interface SoundSearchState {
    isFocused: boolean;
    searchValue: string;
}

export class SoundSearch extends Component<SoundSearchProps, SoundSearchState> {
    searchInput: React.RefObject<HTMLInputElement>;

    constructor(props) {
        super(props);
        this.searchInput = React.createRef();
        this.state = {
            isFocused: false,
            searchValue: ""
        };
    }

    onFocus = () => {
        this.setState({
            isFocused: true
        });
    };

    onBlur = () => {
        this.setState({
            isFocused: false
        });
    };

    onInput = event => {
        this.setState({
            searchValue: event.target.value
        });
    };

    onSelectGame = event => {
        this.props.searchAction(event.target.getAttribute("data-value"));
        this.searchInput.current.value = "";
        this.setState({
            searchValue: "",
            isFocused: false
        });
    };

    filterGameInstances = () => {
        let self = this;
        const availableGameInstances = filterItemsBySelectedGames(
            this.props.gameInstances.results,
            this.props.selectedGroupType,
            this.props.gameGroups,
            instance => instance.identifier
        );

        if (this.state.searchValue === "") {
            return _.filter(availableGameInstances, instance => {
                return !self.props.selectedFilters.selectedGames.includes(
                    instance.description
                );
            });
        } else {
            return _.filter(availableGameInstances, instance => {
                return (
                    instance.description
                        .toUpperCase()
                        .includes(self.state.searchValue.toUpperCase()) &&
                    !self.props.selectedFilters.selectedGames.includes(
                        instance.description
                    )
                );
            });
        }
    };

    componentDidMount() {
        document.addEventListener("click", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }

    handleClickOutside = event => {
        if (!document.querySelector(`#search-games`).contains(event.target)) {
            // save state
            this.setState({
                isFocused: false
            });
        }
    };

    render() {
        const filteteredGameInstances = this.filterGameInstances();

        return (
            <div id="search-games" className="filter-select search-games">
                <input
                    ref={this.searchInput}
                    onFocus={this.onFocus}
                    onInput={this.onInput}
                    placeholder="Search Games"
                />
                {this.state.isFocused && (
                    <div className="search-results">
                        <div>
                            <span>Games</span>
                            <ul>
                                {this.props.gameInstances.results && (
                                    <React.Fragment>
                                        {filteteredGameInstances.length > 0 &&
                                            filteteredGameInstances.map(
                                                instance => {
                                                    return (
                                                        <li
                                                            onClick={
                                                                this
                                                                    .onSelectGame
                                                            }
                                                            key={instance.id}
                                                            data-value={`${instance.description}`}
                                                        >
                                                            {
                                                                instance.description
                                                            }
                                                        </li>
                                                    );
                                                }
                                            )}
                                        {filteteredGameInstances.length ==
                                            0 && <li>No Results</li>}
                                    </React.Fragment>
                                )}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    gameInstances: configurationsStoreSelectors.gameInstances(state),
    gameGroups: configurationsStoreSelectors.gameGroups(state),
    selectedGroupType: configurationsStoreSelectors.selectedGroupType(state)
});

export default connect(
    mapStateToProps,
    {}
)(SoundSearch);
